import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.number.to-fixed.js";
export var formattedFileSize = function formattedFileSize(fileSize) {
  if (typeof fileSize === 'string') {
    fileSize = parseInt(fileSize, 10);
  }
  if (typeof fileSize !== 'number') {
    throw new TypeError('formattedFileSize is expecting string or integer values');
  }
  if (fileSize < 950) {
    return "".concat(fileSize, "B");
  }
  if (fileSize < 999500) {
    return "".concat((fileSize / 1000).toFixed(0), "KB");
  }
  var decimalFileSize = (fileSize / 1000000).toFixed(1);
  var pieces = decimalFileSize.split('.');
  return "".concat(pieces[1] === '0' ? pieces[0] : decimalFileSize, "MB");
};